import { createApiService } from "@/core/api/apiService";
import type { PaymentMethodsDto, SetupConsentDto, SetupDetailsDto, SetupSessionDto, SetupStatusDto } from "../types/paymentMethodTypes";

export function createPaymentMethodApiService() {
  const owner = createApiService("businesses");
  const publicApi = createApiService("payment-method-setups");
  const path = (businessId: string, clientId: string) =>
    `/${encodeURIComponent(businessId)}/clients/${encodeURIComponent(clientId)}/payment-methods`;
  const publicOptions = (signal?: AbortSignal) => ({
    skipAuth: true, cache: "no-store" as const, credentials: "omit" as const, referrerPolicy: "no-referrer" as const, signal,
  });
  return {
    getByClientId: (businessId: string, clientId: string, signal?: AbortSignal) =>
      owner.get<PaymentMethodsDto>(path(businessId, clientId), { signal, cache: "no-store" }),
    createSetupSession: (businessId: string, clientId: string, signal?: AbortSignal) =>
      owner.post<SetupSessionDto>(`${path(businessId, clientId)}/setup-sessions`, {}, { signal, cache: "no-store" }),
    remove: (businessId: string, clientId: string, paymentMethodId: string) =>
      owner.delete<{ success: true }>(`${path(businessId, clientId)}/${encodeURIComponent(paymentMethodId)}`),
    open: (token: string, signal?: AbortSignal) =>
      publicApi.post<SetupDetailsDto>("/open", { token }, publicOptions(signal)),
    consent: (token: string, consentVersion: string, signal?: AbortSignal) =>
      publicApi.post<SetupConsentDto>("/consent", { token, consent_version: consentVersion }, publicOptions(signal)),
    status: (token: string, signal?: AbortSignal) =>
      publicApi.post<SetupStatusDto>("/status", { token }, publicOptions(signal)),
  };
}
export const paymentMethodApiService = createPaymentMethodApiService();
